<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modal__backdrop" @click="closeModal()"/>
      <div class="modal_container">
        <div class="modal__dialog">
          <div class="modal__header">
            <v-btn small
                   rounded
                   icon
                   color="#ff8484"
                   @click="closeModal()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="modal__body">
            <img alt="user_pic" width="135" src="@/assets/images/user.svg">
            <div class="user_info">
              <span style="font-weight: bold">{{ user.name.replaceAll("\"", "") }}</span>
              <span v-if="showRating" style="font-style: italic">
                {{ user.rating }} points
              </span>
            </div>
            <v-btn color="red" @click="unfollowUser" outlined v-if="following">
              UNFOLLOW
            </v-btn>
            <v-btn color="blue" @click="followUser" outlined v-else>
              FOLLOW
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "OtherUserModal",
  data() {
    return {
      show: false
    };
  },
  props: ['user',
    'following',
    'onCreateUserFollow',
    'onDeleteUserFollow',
    'showRating'
  ],

  methods: {
    closeModal() {
      this.show = false;
      document.querySelector("body").classList.remove("overflow-hidden2");
    },

    openModal() {
      this.show = true;
      document.querySelector("body").classList.add("overflow-hidden2");
    },

    async followUser() {
      await this.onCreateUserFollow(this.user.id)
      this.$eventHub.$emit('reloadAll')
      this.$emit('openSnackbar', {message: "User followed successfully", type: "success"})
      this.following = true;
    },

    async unfollowUser() {
      await this.onDeleteUserFollow(this.user.id)
      this.$eventHub.$emit('reloadAll')
      this.$emit('openSnackbar', {message: "User unfollowed successfully", type: "success"})
      this.following = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.user_info {
  display: flex;
  flex-direction: column;
}

.modal {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;

  .modal_container {
    display: flex;
    justify-content: center;
    margin-top: 30vh;
  }

  &__backdrop {
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 3;
  }

  &__dialog {
    background-color: #ffffff;
    position: relative;
    width: 30vw;
    margin: 50px auto;
    display: flex;
    flex-direction: column;
    border-radius: 15px;
    z-index: 4;

    @media screen and (max-width: 992px) {
      width: 90%;
    }
  }

  &__close {
    width: 30px;
    height: 30px;
  }

  &__header {
    padding: 20px 20px 10px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  }

  &__body {
    padding: 10px 20px 10px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  &__footer {
    padding: 10px 20px 20px;
  }

}

.fade-enter-active,
.fade-leave-active {
  transition: opacity ease-in 0.2s;
  animation: popup 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@keyframes popup {
  0% {
    transform: scale(1);
  }
  60% {
    transform: scale(1.2);
  }
  70% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

</style>
